import { Component, ViewChild } from '@angular/core';
import { AppService } from 'app/app.service';
import { CoreFeedbackModalComponent } from '../core-feedback-modal/core-feedback-modal.component';
import { ModalGlobalSearchComponent } from 'app/modal/modal-global-search/modal-global-search.component';

@Component({
	selector: 'app-core-header',
	templateUrl: './core-header.component.html'
})
export class CoreHeaderComponent {

	@ViewChild(CoreFeedbackModalComponent) feedbackModal;
	@ViewChild(ModalGlobalSearchComponent) globalSearchModal: ModalGlobalSearchComponent;

	showPaymentWarning = true;

	constructor(
		public app: AppService
	) { }

	/**
	 * Advanced search is an opt-in feature (organisation.allow_global_search) - the same condition
	 * api-globalsearch.php gates the module on, so the icon can't offer what the API would refuse.
	 */
	get showsGlobalSearch() {
		return !!this.app.org && !!this.app.orgInfo?.allow_global_search;
	}

	showFeedbackModal() {
		this.feedbackModal.open();
	}

	showGlobalSearchModal(data) {
		this.globalSearchModal.open(data);
	}

}
